
import { defineComponent, ref } from 'vue';
import { apiClient } from '@/lib/api/client';

interface LookupResult {
  succeeded: boolean;
}

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    holder: {
      type: String,
      required: false,
      default: 'Permis de conduire',
    },
  },

  setup(props, context) {
    const lookupResult = ref<LookupResult | null>(null);
    const working = ref(false);

    const update = (event: InputEvent) => {
      context.emit('update:modelValue', (event.target as HTMLInputElement).value);
    };

    const reset = () => {
      lookupResult.value = null;
      context.emit('lookup', null);
    };

    const lookupOdooId = async () => {
      if (!props.modelValue) return;

      working.value = true;
      lookupResult.value = null;
      try {
        const { data, response } = await apiClient.GET('/odoo/lookup/{partnerRef}', {
          params: {
            path: {
              partnerRef: props.modelValue,
            },
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch driver licence');
        }

        lookupResult.value = {
          succeeded: true,
        };
        context.emit('lookup', data);
      } catch (e) {
        console.error(e);
        lookupResult.value = {
          succeeded: false,
        };
      } finally {
        working.value = false;
      }
    };

    return {
      working,
      lookupResult,
      lookupOdooId,
      update,
      reset,
    };
  },
});
